import { gql } from '@apollo/client';

export const queryAms = gql`
  mutation QueryAms($idempotencyKey: String!, $input: QueryAmsInput!) {
    queryAms(idempotencyKey: $idempotencyKey, input: $input) {
      transaction {
        id
        version
      }
    }
  }
`;
